<template>
  <div class="all-wrapper menu-side with-pattern">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="element-box">
          <div class="logo-w">
            <a href="#"><img class="box-logo" :alt="allTemplateDetails.name" width="20%" :src="allTemplateDetails.loginLogoImage"></a>
          </div>
          <div class="translationBox">
            <Translation style="display: inline-block; margin-right: 10px;"></Translation>
            <router-link :to="{ path: '/' }" class="btn btn-primary">{{ t('forgotPasswordFormSignInButtonText','forgotPasswordFormSignInButtonText') }}</router-link>
          </div>
          <ResponseInfo v-if="getResponseInfo.responseName == 'forgotPassword'" class="mt-4"></ResponseInfo>
        </div>
      </div>
    </div>
    <div class="row text-center" style="margin: 0px; display: flex; justify-content: center;">
      <div v-if="hintEnabled" class="col-lg-4 col-sm-12 col-md-12">
          <div class="element-box">
            <form class="box-1" action="" v-on:submit.prevent="sendUserPasswordHint">
              <div class="box-header">
                <div class="box-icon pre-icon os-icon os-icon-mail-07" style="display: inline-block"></div>
                <h5 class="form-header">{{ t('forgotPasswordHintHeader','forgotPasswordHintHeader') }}</h5>
              </div>
              <hr />
              <div class="form-group">
                <span class="red">*</span><label for="">{{ t('forgotPasswordFormEmailAddressText','forgotPasswordFormEmailAddressText') }}</label>
                <input id="hintEmailAddress" v-model="hintEmailAddress" class="form-control" :placeholder="t('forgotPasswordFormEmailAddressPlaceholder', 'forgotPasswordFormEmailAddressPlaceholder')" type="email" required>
              </div>
              <small>{{ t('forgotPasswordHintDesc','forgotPasswordHintDesc') }}</small>
              <div class="buttons-w">
                <button v-if="!getSpinner" type="submit" class="btn btn-primary">{{ t('forgotPasswordFormSendHintButtonText','forgotPasswordFormSendHintButtonText') }}</button>
                <div v-if="getSpinner" class="loader"></div>
              </div>
            </form>
          </div>
        </div>
        <div v-if="reminderEnabled" class="col-lg-4 col-sm-12 col-md-12">
          <div class="element-box">
            <form class="box-2" action="" v-on:submit.prevent="sendUserPasswordReminder">
              <div class="box-header">
                <div class="box-icon pre-icon os-icon os-icon os-icon-mail-18" style="display: inline-block"></div>
                <h5 class="form-header">{{ t('forgotPasswordReminderHeader','forgotPasswordReminderHeader') }}</h5>
              </div>
              <hr />
              <div class="form-group">
                <span class="red">*</span><label for="">{{ t('forgotPasswordFormEmailAddressText','forgotPasswordFormEmailAddressText') }}</label>
                <input id="reminderEmailAddress" v-model="reminderEmailAddress" class="form-control" :placeholder="t('forgotPasswordFormEmailAddressPlaceholder', 'forgotPasswordFormEmailAddressPlaceholder')" type="email" required>
              </div>
              <small>{{ t('forgotPasswordReminderDesc','forgotPasswordReminderDesc') }}</small>
              <div class="buttons-w">
                <button v-if="!getSpinner" type="submit" class="btn btn-primary">{{ t('forgotPasswordFormSendReminderButtonText','forgotPasswordFormSendReminderButtonText') }}</button>
              </div>
            </form>
          </div>
        </div>
        <div v-if="resetEnabled" class="col-lg-4 col-sm-12 col-md-12">
          <div class="element-box">
            <form action="" v-on:submit.prevent="retrieveUserLoginDetails">
              <div class="form-group">
                <!-- document-17  cv-2 -->
                <div class="box-header">
                  <div class="box-icon pre-icon os-icon os-icon os-icon-cv-2" style="display: inline-block"></div>
                  <h5 class="form-header">{{ t('forgotPasswordRetrieveHeader','forgotPasswordRetrieveHeader') }}</h5>
                </div>
                <hr />
                <span class="red">*</span><label for="">{{ t('forgotPasswordFormEmailAddressText','forgotPasswordFormEmailAddressText') }}</label>
                <input id="emailAddress" v-model="emailAddress" class="form-control" :placeholder="t('forgotPasswordFormEmailAddressPlaceholder', 'forgotPasswordFormEmailAddressPlaceholder')" type="email" required>
              </div>
              <small>{{ t('forgotPasswordRerieveDesc','forgotPasswordRerieveDesc') }}</small>
              <div class="buttons-w">
                <button v-if="!getSpinner" type="submit" class="btn btn-primary">{{ t('forgotPasswordFormResetButtonText','forgotPasswordFormResetButtonText') }}</button>
                <div v-if="getSpinner" class="loader"></div>
              </div>
            </form>
          </div>
        </div>
        <div v-if="clientName != 'gskp' && clientName != 'gskptest'" class="col-lg-4 col-sm-12 col-md-12">
          <div class="element-box">
            <form action="" v-on:submit.prevent="retrieveUserEmailHint()">
              <div class="form-group">
                <!-- NS-9876 Password hint box -->
                <div class="box-header">
                  <div class="box-icon pre-icon os-icon os-icon os-icon-cv-2" style="display: inline-block"></div>
                  <h5 class="form-header">{{ t('forgotEmailHintHeader','forgotEmailHintHeader') }}</h5>
                </div>
                <hr />
                <span class="red">*</span><label for="">{{ t('forgotEmailHintCustomerLabel','forgotEmailHintCustomerLabel') }}</label>
                <input id="customerReference" v-model="customerReference" class="form-control" :placeholder="t('customerReferenceTextPlaceholder', 'customerReferenceTextPlaceholder')" type="text" required>
                <span class="red">*</span><label for="">{{ t('forgotEmailHintUserPassLabel','forgotEmailHintUserPassLabel') }}</label>
                <div class="form-group">
                  <div style="position: relative;">
                    <input id="userPassword" v-model="userPassword" class="form-control" :placeholder="t('userPasswordTextPlaceholder', 'userPasswordTextPlaceholder')" :type="hintType" required>
                    <div @click="toggleHintPassword()" class="show-pass">
                      <i id="showPasswordIcon" v-bind:class="{ 'os-icon-eye': eyeOn, 'os-icon-eye-off': eyeOff }" class="os-icon" title="Show password"></i>
                    </div>
                  </div>
                </div>
              </div>
              <small>{{ t('forgotEmailHintDesc','forgotEmailHintDesc') }}</small>
              <div class="col-12 px-0">
                <ResponseInfo v-if="getResponseInfo.responseName == 'forgotEmailHint' && !emailHint" class="mt-2 px-0"></ResponseInfo>
                <template v-if="emailHint">
                  <hr class="mb-2">
                  <div class="col-12 row">
                    <span class="col-12" v-for="hint in emailHint" :key="hint">{{ hint }}</span>
                  </div>
                </template>
              </div>
              <div class="buttons-w">
                <button v-if="!getSpinner" type="submit" class="btn btn-primary">{{ t('forgotEmailHintBtnText','forgotEmailHintBtnText') }}</button>
                <div v-if="getSpinner" class="loader"></div>
              </div>
            </form>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Translation from '@/components/Translation.vue'
import ResponseInfo from '@/components/ResponseInfo.vue'
import { clientShortName } from '@/helpers/clientShortName.js'

export default {
  name: 'forgot_password',
  data() {
    return {
      hintEmailAddress: '',
      reminderEmailAddress: '',
      emailAddress: '',
      emailHint: null,
      eyeOn: true,
      eyeOff: false,
      customerReference: null,
      userPassword: null,
      hintType: 'password'
    }
  },
  components: {
    Translation,
    ResponseInfo
  },
  methods: {
    toggleHintPassword() {
      this.hintType = this.hintType == 'password' ? 'text' : 'password'
      this.eyeOn = this.eyeOn ? false : true
      this.eyeOff = this.eyeOff ? false : true
    },
    retrieveUserLoginDetails(){
        this.$store.dispatch('retrieveUserLoginDetails', this.emailAddress )
        this.emailAddress = ''
    },
    changeBackgroud(){
      document.body.style.backgroundImage = "url("+this.$store.getters.allTemplateDetails.loginBackgroundImage+"),  linear-gradient(to top, #00c6fb 0%, #005bea 100%)";
      document.body.style.backgroundAttachment = "fixed";
    },
    sendUserPasswordHint() {
      this.$store.dispatch('sendUserPasswordHint', this.hintEmailAddress)
      this.hintEmailAddress = ''
    },
    sendUserPasswordReminder() {
      this.$store.dispatch('sendUserPasswordReminder', this.reminderEmailAddress)
      this.reminderEmailAddress = ''
    },
    // NS-9876 Function to retrieve user email hint, PW
    retrieveUserEmailHint() {
      this.$store.dispatch('retrieveUserEmailHint', {
        customerReference: this.customerReference,
        userPassword: this.userPassword
      }).then(response => {
        this.emailHint = response.emailHints
        this.customerReference = null
        this.userPassword = null
      })
    }
  },
  computed:{
      ...mapGetters(['allTemplateDetails','getSpinner', 'getResponseInfo']),
      hintEnabled() {
        return this.$store.getters.allTemplateDetails.allow_password_hints == 1 ? true : false
      },
      reminderEnabled() {
        return this.$store.getters.allTemplateDetails.allow_password_reminders == 1 ? true : false
      },
      resetEnabled() {
        return this.$store.getters.allTemplateDetails.allow_password_resets == 1 ? true : false
      },
      clientName() {
        let clientName = clientShortName()
        return clientName
      }
  },
  created(){
      this.changeBackgroud()   
  }
}
</script>

<style scoped>
  .box-1, .box-2 {
    padding-bottom: 20px;
  }
  .form-group {
    margin-bottom: 5px;
    position: relative;
  }
  .form-header {
    margin-bottom: 0.5rem;
    display: inline-block;
  }
  .box-header {
    display: flex;
    align-items: center;
  }
  .box-icon {
    font-size: 24px;
    color: #047bf8;
    margin-right: 5px;
  }
  .buttons-w {
    padding-top: 1rem;
    margin-top: 0.5rem;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
  }
  .red {
    color: red;
  }
  .element-box {
    position: relative;
  }
  .translationBox {
    position: absolute;
    right: 20px;
    top: 20px;
    margin-right: 0px;
  }
  .show-pass {
    position: absolute;
    right: 10px;
    bottom: 0;
    top: 0;
    display: flex;
    align-items: center;
  }
  .show-pass > .os-icon-eye,  .show-pass > .os-icon-eye-off{
    font-size: 24px;
    color: rgba(4, 121, 246, 0.50);
  }
  @media (max-width: 768px) {
    .box-logo {
      width: 100%;
    }
    .translationBox {
      float: unset;
      text-align: right;
      position: initial;
    }
  }
</style>